import { cx } from '@twind/core';
import { FeedbackSentiment } from 'app/hooks/fetch/useFeedbackAnalytics';
import { useTranslation } from 'react-i18next';

import ThumbsDownIcon from '../icons/ThumbsDownIcon';

export default function NegativeFeedbackButton({
  onClick,
  filled,
}: {
  onClick: (feedbackSentiment: FeedbackSentiment) => void;
  filled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <button
      onClick={() => onClick(FeedbackSentiment.NEGATIVE)}
      className="rounded-full"
      aria-label={t('feedback.no_label')}
      data-testid="feedback-thumbs-down"
      aria-pressed={filled}
    >
      <ThumbsDownIcon
        className={cx('w-4 h-4')}
        filled={filled}
      />
    </button>
  );
}
